import Transformer from './../transformer'

export default class ProviderTransformer extends Transformer {
  static fetch({provider_type ,...provider }) {
    const providerType = Array.isArray(provider_type) ? provider_type[0] : {}
    return {
      providerTypeId: providerType.id,
      ...provider
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/provider.js